import { View } from 'react-native';
import { Text } from '@/components/ui/text';
import { Icon } from '~/global/components/icon/Icon';
import { WorkoutCompletionStatus, WorkoutUtils } from '@fytness/shared';
import { PageHeader } from '~/layout/components/page-header/PageHeader';
import { RightSidebar } from '~/layout/components/right-sidebar/RightSidebar';
import { WorkoutHeaderActions } from '~/workout/components/workout-header-actions/WorkoutHeaderActions';
import type { WorkoutRecord } from '~/powersync/generated/schema';

export interface WorkoutMobileHeaderProps {
  title: string;
  workout?: WorkoutRecord | null;
  className?: string;
}

/**
 * Compact mobile header for the workout builder / detail screens:
 * back button + title on the left, and on the right either the live
 * in-progress controls or a static timer placeholder. Hidden on desktop,
 * where {@link WorkoutBuilderHeader} renders the sidebar header instead.
 */
export const WorkoutMobileHeader = ({
  title,
  workout,
  className,
}: WorkoutMobileHeaderProps) => {
  const isWorkoutInProgress =
    workout &&
    WorkoutUtils.getCompletionStatus(workout) ===
      WorkoutCompletionStatus.STARTED;

  return (
    <PageHeader
      className={className}
      title={title}
      actions={
        <View className="flex-row items-center gap-2">
          {isWorkoutInProgress ? (
            <WorkoutHeaderActions workout={workout} />
          ) : (
            <View className="flex-row items-center gap-1 rounded-lg bg-surface px-2.5 py-1.5">
              <Text className="text-xs font-inter-medium text-text-primary">
                00:00
              </Text>
              <Icon name="Play" size={12} className="text-text-primary" />
            </View>
          )}
          {/* Opens the generic right-sidebar drawer; self-hides in create mode. */}
          <RightSidebar.Trigger />
        </View>
      }
    />
  );
};
